import React, { useRef, useEffect } from "react";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";

export const MultiselectAccountsDropdown = (props: any) => {
    const wrapperRef = useRef(null);
    const { label, placeholder, isOpen, onToggle, disable, title } = props;

    const handleClickOutside = () => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {onToggle(false);}
    };

    const ToggleDropdown = () => {
        onToggle(!isOpen);
    };

    useEffect(() => {
        document.addEventListener("touchstart", handleClickOutside);
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("touchstart", handleClickOutside);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const CSSClasses = classNames("form-group multiselect-dropdown accounts", props.cssWrapper, { "is-open": isOpen });

    return (
        <div className={CSSClasses} ref={wrapperRef}>
            <label className="control-label" id={props.id}>
                {label}
            </label>
            <div className="controls-wrap">
                <button
                    className="trigger"
                    onClick={() => ToggleDropdown()}
                    aria-expanded={isOpen}
                    disabled={disable}
                    title={title}
                >
                    <span className="text">{placeholder}</span>
                    <span className="icon" aria-hidden={true} />
                </button>
                {!disable && (
                    <CSSTransition in={isOpen} timeout={300} unmountOnExit classNames="a-dropdown">
                        <div className="dropdown-list" aria-hidden={!isOpen}>
                            <div className="dropdown-list-panel">{props.children}</div>
                        </div>
                    </CSSTransition>
                )}
            </div>
        </div>
    );
};
